import React from 'react';
import Typography from '@material-ui/core/Typography';
import Title from './Title';

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const CardAfiliado = (props) => {
  const { dataAfiliado, autopercepcionAfi } = props;

  const calcularEdad = (fechaNacimiento) => {
    const fechaNacimientoObj = new Date(fechaNacimiento);
    const fechaActual = new Date();
    const edad = fechaActual.getFullYear() - fechaNacimientoObj.getFullYear();
    // Verificar si ya pasó el cumpleaños de la persona en el año actual
    if (
      fechaActual.getMonth() < fechaNacimientoObj.getMonth() ||
      (fechaActual.getMonth() === fechaNacimientoObj.getMonth() &&
        fechaActual.getDate() < fechaNacimientoObj.getDate())
    ) {
      return edad - 1;
    }
    return edad;
  };

  return (
    <React.Fragment>
      <Title>Datos Paciente</Title>
      <Typography variant="h6">
        Nombre: {dataAfiliado?.apellido_y_nombre}
      </Typography>
      {autopercepcionAfi &&
        (
          <Typography variant="h6">
            
            <span style={{ color: 'red' }}> Nombre autopercibido: {autopercepcionAfi?.apeNom}</span>
          </Typography>
        )
      }
      <Typography variant="h6">
        Edad: {calcularEdad(dataAfiliado?.fecha_nacimiento)}
        {dataAfiliado?.incapacitado === 1 && (
          <span style={{ color: 'red' }}> INCAPACITADO</span>
        )}
      </Typography>
      <Typography variant="h6">
        FechaNacimiento:{' '}
        {new Date(dataAfiliado?.fecha_nacimiento).toLocaleString(
          'es',
          optionsfecha,
        )}
      </Typography>
      <Typography variant="h6">
        Nro Beneficiario: {dataAfiliado?.carnet}
      </Typography>
      <Typography variant="h6">
        Domicilio: {dataAfiliado?.domiciliosAfiliados?.calle}{' '}
        {dataAfiliado?.domiciliosAfiliados?.nro}
      </Typography>
      <Typography variant="h6">
        Telefono: {dataAfiliado?.domiciliosAfiliados?.telefono}
      </Typography>
      <Typography variant="h6">
        Celular: {dataAfiliado?.domiciliosAfiliados?.celular}
      </Typography>
      <Typography variant="h6">
        Email: {dataAfiliado?.domiciliosAfiliados?.mail}{' '}
      </Typography>
    </React.Fragment>
  );
};
